import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const EmptyData: React.VFC = () => {
  return (
    <div className={styles['container']}>
      <UIText1>Нет данных.</UIText1>
      <UIText1>Не нашли похожих объектов. Зайдите позже или выберите другой фильтр</UIText1>
    </div>
  );
};
